import { render, staticRenderFns } from "./confirm.vue?vue&type=template&id=e6bd637a&scoped=true&lang=pug&"
import script from "./confirm.vue?vue&type=script&lang=js&"
export * from "./confirm.vue?vue&type=script&lang=js&"
import style0 from "./dialogs.scss?vue&type=style&index=0&id=e6bd637a&lang=scss&scoped=true&"
import style1 from "./confirm.vue?vue&type=style&index=1&id=e6bd637a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6bd637a",
  null
  
)

export default component.exports